var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h-2c-.6 0-1 .4-1 1s-.4 1-1 1-1-.4-1-1-.4-1-1-1H7c-.6 0-1 .4-1 1s-.4 1-1 1-1-.4-1-1-.4-1-1-1H1c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm-8 9H3V7h4v4zm6 0H9v-1h4v1zm0-3H9V7h4v1z",
    fill: "#4B3479"
  })));
}

export default SvgBadge;